export default __webpack_public_path__ + "static/media/e-sip-dpo-logo-a_12092026.41d28935.png";